function camelToSnake(str: string): string {
  return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function convertKeysToSnakeCase(input: unknown): unknown {
  if (Array.isArray(input)) {
    return input.map(convertKeysToSnakeCase);
  }

  if (input !== null && typeof input === "object") {
    return Object.keys(input).reduce(
      (acc, key) => {
        const snakeKey = camelToSnake(key);
        const value = (input as Record<string, unknown>)[key];
        acc[snakeKey] = convertKeysToSnakeCase(value);
        return acc;
      },
      {} as Record<string, unknown>,
    );
  }

  return input;
}
